'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickAction {
  id: string;
  label: string;
  icon: string;
  onClick: () => void;
}

interface QuickActionButtonProps {
  actions?: QuickAction[];
  className?: string;
}

const QuickActionButton = ({
  actions = [],
  className = '',
}: QuickActionButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const defaultActions: QuickAction[] = [
    {
      id: 'scan',
      label: 'Scan Medication',
      icon: 'CameraIcon',
      onClick: () => console.log('Scan medication'),
    },
    {
      id: 'emergency',
      label: 'Emergency Contacts',
      icon: 'PhoneIcon',
      onClick: () => console.log('Emergency contacts'),
    },
    {
      id: 'task',
      label: 'Create Task',
      icon: 'PlusCircleIcon',
      onClick: () => console.log('Create task'),
    },
    {
      id: 'note',
      label: 'Quick Note',
      icon: 'PencilSquareIcon',
      onClick: () => console.log('Quick note'),
    },
  ];

  const actionList = actions.length > 0 ? actions : defaultActions;

  const handleActionClick = (action: QuickAction) => {
    action.onClick();
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={`fixed bottom-20 right-6 lg:bottom-6 z-60 ${className}`}
      >
        {isOpen && (
          <div className="absolute bottom-16 right-0 mb-2 space-y-2 animate-slide-in-up">
            {actionList.map((action, index) => (
              <button
                key={action.id}
                onClick={() => handleActionClick(action)}
                className="flex items-center gap-3 w-full px-4 py-3 glass text-foreground rounded-lg shadow-warm-md hover:shadow-warm-lg transition-smooth hover:scale-[1.02] active:scale-[0.98]"
                style={{
                  animationDelay: `${index * 50}ms`,
                }}
              >
                <Icon
                  name={action.icon as any}
                  size={20}
                  className="text-primary"
                />
                <span className="text-sm font-caption font-medium whitespace-nowrap">
                  {action.label}
                </span>
              </button>
            ))}
          </div>
        )}

        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-warm-lg hover:shadow-warm-xl transition-smooth hover:scale-105 active:scale-95 flex items-center justify-center ${
            isOpen ? 'rotate-45' : ''
          }`}
          aria-label={isOpen ? 'Close quick actions' : 'Open quick actions'}
        >
          <Icon
            name="PlusIcon"
            size={28}
            className="transition-smooth"
          />
        </button>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-background"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default QuickActionButton;